import React, { FunctionComponent, useEffect } from 'react'
import { CurrentUserType } from '../../ducks/auth'
import Amplitude from '../../utils/amplitudeHelper'
import { PageStyle } from './styled'
import { SessionDateTab } from 'src/components/Agenda/SessionDateTab'
import { SessionContainer } from 'src/components/Agenda/SessionContainer'
import { useWindowSize } from '../../utils/useWindowSize'
import { useHistory } from 'react-router'
import routes from 'src/routes'

interface MobileAgendaTypes {
  currentUser: CurrentUserType
}

const MobileAgenda: FunctionComponent<MobileAgendaTypes> = ({ currentUser }) => {
  const history = useHistory()
  const { windowHeight } = useWindowSize()

  useEffect(() => {
    Amplitude.visit('Programme Page')
  }, [currentUser.id])


  return (
    <PageStyle mobileHeight={windowHeight}>
      <header>
        <div className="header-banner"></div>
      </header>
      <section className="container mb-3">
        <button className='auditorium-btn' onClick={() => history.push(routes.auditorium1)}>Enter Auditorium</button>
        <SessionDateTab />
        <SessionContainer currentUser={currentUser} />
      </section>
    </PageStyle>
  )
}

export default MobileAgenda